import { TenantActionsBodyCell } from '../components/TenantsTable/TenantActionsBodyCell';
import { useActionsColumn } from '../../../features/table/helpers/useActionsColumn';
import { TenantT } from '../../../lib/types/tenants';

export const useTenantActionsColumn = () => {
  return useActionsColumn({
    render: (_text: unknown, row: TenantT) => <TenantActionsBodyCell row={row} />,
  });
};
